<template>
  <div class="view pa24">
    <div class="d-flex">
      <el-button class="ma mr10" type="primary" @click="handleAddDealer('add')" >+添加经销商</el-button>
      <el-button class="ma" type="primary" @click="exportDealer" >导入经销商</el-button>
    </div>
    <commonTable :tableData="tableData" :total="total" :currentPage="pageNum" @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange">
      <template v-slot:table>
        <el-table-column prop="dealerName" align="center" label="经销商名称" />
        <el-table-column prop="code" align="center" label="代号" />
        <el-table-column prop="liaison" align="center" label="联系人" />
        <el-table-column prop="phone" align="center" label="电话" />
        <el-table-column align="center" prop="address" label="经销商地址">
        </el-table-column>
        <el-table-column align="center" width="200" label="销售区域">
          <template slot-scope="scope">
            <div v-if="scope.row.area[0] != null">
              <div v-for="item in scope.row.area" :key="item.id">
                {{item.address}}
              </div>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
<!-- 绑定设备数量 -->
        <el-table-column  prop="deviceNum" align="center"  label="绑定设备数量" v-if="checkPermission(['gps_device_btn'])">
        </el-table-column>
        <!-- 疑似串货数量 -->
        <el-table-column  prop="suspectNum" align="center"  label="疑似串货数量" v-if="checkPermission(['gps_device_btn'])">
        </el-table-column>
        <el-table-column align="center" width="200" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="editDealar(scope.row)" >编辑</el-button>
            <el-button type="text" style="color: red" @click="deleteDealar(scope.row)">删除</el-button>
            <el-button type="text" :class="{'active':!scope.row.disabled}"  @click="setDisabled(scope.row)" v-if="checkPermission(['disabled_btn'])" >{{scope.row.disabled?'取消禁用':'禁用'}}</el-button>
          </template>
        </el-table-column>
      </template>
    </commonTable>

    <AddDealerDialog ref="addDealerDialog" @getList="getList"></AddDealerDialog>
    <ExportDealerDialog ref="exportDealerDialog" @getList="getList"></ExportDealerDialog>
  </div>
</template>

<script>
  import AddDealerDialog from './components/AddDealerDialog'
  import ExportDealerDialog from './components/exportDealerDialog'
  import commonTable from "@/components/common/commonTable";
  import { fetchDealList, fetchDeleteDeal,fetchBlockDealer,fetchDealerDisabled } from '@/api/companyManage.js'
  import {checkPermission} from "@/directives/permission";

  export default {
    name: "dealerList",
    components: {
      commonTable,
      AddDealerDialog,
      ExportDealerDialog
    },
    data() {
      return {
        tableData: [],
        pageSize: 10,
        pageNum: 1,
        total: 0,
        userInfo:'',
        showBtn:false
      };
    },
    created() {
      this.userInfo = JSON.parse(localStorage.getItem('info'));
      // if (this.userInfo.userType == 3||this.userInfo.userType == 9||this.userInfo.userType == 2){
      //   this.showBtn = true
      // }
      // if (this.userInfo.companyId == 288||this.userInfo.companyId == 289) {
      //   this.showBtn = true
      // }
      console.log('userInfo',this.userInfo)
      this.getList()
    },
    methods: {
      checkPermission,
      setDisabled(row){
        this.$confirm('此操作将'+(row.disabled?'取消禁用':'禁用')+'该账号, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          fetchDealerDisabled({id: row.id}).then(res=>{
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
            this.getList()
          })
        }).catch(() => {

        });
      },
      handleSizeChange(num) {
        this.pageSize = num;
        this.pageNum = 1;
        this.getList();
      },
      handleCurrentChange(num) {
        this.pageNum = num;
        this.getList();
      },
      handleAddDealer(type, id) {
        this.$refs.addDealerDialog.openDialog(type, id)
      },
       exportDealer() {
        this.$refs.exportDealerDialog.openDialog()
      },
      getList() {
        let params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          // type: 2,
          companyId: JSON.parse(localStorage.getItem('info')).companyId,
        }
        fetchDealList(params).then(res => {
          this.tableData = res.data.list
          this.total = res.data.total
        })
      },
      editDealar(data) {
        this.$refs.addDealerDialog.openDialog('edit', data)
      },
      deleteDealar(data) {
        let params = {
          id: data.id
        }
        this.$confirm('此操作将永久删除该经销商, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          fetchDeleteDeal(JSON.stringify(params)).then(res => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功",
              });
              this.getList()
            }
          })
        }).catch(() => {

        });
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ma {
  margin-right: 10px; /* 你可以根据需要调整这个值 */
}
  .active{
    color: red;
  }
</style>
